import React, { memo } from "react";
import PropTypes from "prop-types";
import "./style.scss";
function RadioGender({
  variant,
  disabled,
  onChange,
  refGenderList,
  currentIndex,
  cls,
}) {
  RadioGender.propTypes = {
    variant: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      checked: PropTypes.bool,
      label: PropTypes.string,
      value: PropTypes.string,
    }),
    refGenderList: PropTypes.object,
    disabled: PropTypes.bool,
    currentIndex: PropTypes.number,
    onChange: PropTypes.func,
    cls: PropTypes.arrayOf(PropTypes.string),
  };
  return (
    <div key={variant.id} className="radio-variant">
      <input
        disabled={disabled}
        onChange={onChange}
        className={cls.join(" ")}
        checked={variant.checked}
        value={variant.value}
        type="radio"
        ref={(ref) => (refGenderList.current[currentIndex] = ref)}
        name={variant.name}
        id={variant.id}
      />
      <label htmlFor={variant.id}>{variant.label}</label>
    </div>
  );
}

export default memo(RadioGender);
